import {
  CONTINUE_ONLINE_ADD_ADHD_PATH,
  CONTINUE_ONLINE_ADVERSE_DRIVING_PATH,
  CONTINUE_ONLINE_ANXIETY_PATH,
  CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH,
  CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH,
  CONTINUE_ONLINE_FAMILY_HISTORY_PATH,
  CONTINUE_ONLINE_MARIJUANA_PATH,
  CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH,
} from 'routes/constants';

import { Step } from './types';

export const UNDERWRITING_STEPS: Step[] = [
  {
    key: 'urn:pg:data-point:insured-gender',
    value: 'female',
    path: CONTINUE_ONLINE_PREGNANCY_HISTORY_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-condition-high-blood-pressure',
    value: true,
    path: CONTINUE_ONLINE_BLOOD_PRESSURE_DETAILS_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-condition-high-cholesterol',
    value: true,

    path: CONTINUE_ONLINE_CHOLESTEROL_DETAILS_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-condition-add-adhd',
    value: true,
    path: CONTINUE_ONLINE_ADD_ADHD_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-condition-anxiety',
    value: true,
    path: CONTINUE_ONLINE_ANXIETY_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-risk-condition-family-health-history',
    value: true,
    path: CONTINUE_ONLINE_FAMILY_HISTORY_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-risk-condition-marijuana',
    value: true,
    path: CONTINUE_ONLINE_MARIJUANA_PATH,
  },
  {
    key: 'urn:pg:data-point:insured-risk-activity-adverse-driving',
    value: true,
    path: CONTINUE_ONLINE_ADVERSE_DRIVING_PATH,
  },
];
